import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './error-boundary'

const View = lazy(() => import('./view'))

const MonitorPage = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <View />
            </ErrorBoundary>
        </Suspense>
    )
}

export default MonitorPage
